/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { INSPECTOR_NODE_TYPE, TInspectorNode } from "../InspectorNodeTypes";
import { ISchemaIntegrationRefModel, isSchemaIntegrationRefModel } from "@adapptio/lib-blueprint";
import { mapModelToNodes } from "../index";
import { mapperDescriptor } from "../../modules/Core/ReferenceGuide/mappers/mapperDescriptor";
import { mapperExamples } from "../../modules/Core/ReferenceGuide/mappers/mapperExamples";
import { getParentComponentName } from "../utils";
import { IInspectorControl_IntegrationSelector, INSPECTOR_CONTROL_TYPE } from "../controls";
import { createDefaultNode } from "../createDefaultNode";

export function integrationRefMapper(model: ISchemaIntegrationRefModel): TInspectorNode {
	if (!isSchemaIntegrationRefModel(model)) {
		return;
	}

	const control: IInspectorControl_IntegrationSelector = {
		key: `${model.nodeId}`,
		type: INSPECTOR_CONTROL_TYPE.INTEGRATION_SELECTOR,
		model
	};

	const paramsNode = mapModelToNodes(model.params);

	return {
		type: INSPECTOR_NODE_TYPE.DEFAULT,
		key: `${model.nodeId}`,
		label: model.schema.opts.label,
		tooltip: model.schema.opts.description,
		required: model.schema.opts.constraints?.required || false,
		default: model.schema.opts["default"] || null,
		options: model.schema.opts["options"],
		referenceData: getParentComponentName(model),
		descriptor: mapperDescriptor(model.schema),
		examples: mapperExamples(model.schema),
		deps: [ model, ...paramsNode.deps ],
		controls: [],
		children: [
			() =>
				createDefaultNode({
					controls: [ control ]
				}),
			() => mapModelToNodes(model.params)
		]
	};
}
